import { observer } from 'mobx-react';
import UtilizationBanner from '../../../../../LearningCollectionSteps/UtilizationBanner';
import ListIcon from '../../../../../../../Cutesies/ListIcon';
import { AlreadyTranslated, AlreadyTranslatedText, T } from '../../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../../Edit/Store';
import { SectionContext } from '../../../../../Types';

interface Props {
  learningDesignName: AlreadyTranslatedText;
  learningCollectionStore: LearningCollectionEditStore;
  context: SectionContext;
}

function CardBanner({ learningDesignName, learningCollectionStore, context }: Props) {
  return (
    <div className="inset-x-0 flex justify-between bg-[#187a9040] px-11 py-5 text-sm">
      <p>
        <T
          kind="Adding to <learningDesign/>"
          learningDesign={
            <span className="text-teal-600">
              <AlreadyTranslated content={learningDesignName} />
            </span>
          }
        />
      </p>
      <div className="flex">
        <div className="flex mr-4">
          <UtilizationBanner
            store={learningCollectionStore}
            placementProps={{
              marginTop: 'mt-1',
              position: { top: 'top-12', right: 'right-[165px]' },
            }}
          />
        </div>
        <ListIcon />
        <p className="ml-2">
          <T
            kind="{{count}} program"
            count={learningCollectionStore.experienceStores(context).length}
          />
        </p>
      </div>
    </div>
  );
}

export default observer(CardBanner);
